import React from 'react'
import PropTypes from 'prop-types'

import ProjectNotesListItem from './ProjectNotesListItem'

const ProjectNotesList = (props) => {

    return (
        <div className="d-flex flex-column">
            {
                props.notes.map((note, index) => <ProjectNotesListItem key={index} project_id={props.project_id} {...note}/>)
            }
        </div>
    )

}

ProjectNotesList.propTypes = {
    project_id: PropTypes.string.isRequired
}

export default ProjectNotesList